import { constants } from "../../../constants";

export default class GameLoadProgress {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    WZD_handler(payload) {
        if (payload && payload.param && payload.param.progress > 0) {
            this.gb.emitters.emit.web.gameLoadProgress({payload: {progress: payload.param.progress}});
        }
    }

    SPIN_handler(data) {
        this.gb.emitters.emit.web.gameLoadProgress({payload: {progress: data.value / 100}});
    }

    ENDOR_handler(data) {
        let progress = data.progress || data.payload?.progress;

        this.gb.emitters.emit.web.gameLoadProgress({
            payload: { progress },
        });
    }

    _default(data) {
        this.gb.emitters.emit.web.gameLoadProgress(data);

        try {
            // some games send gameLoadEnd event after splash screen button is pressed ... if there is an overlay over game (Casino logo etc...) then this button is not accessible ... this way event should always be triggered ...
            if (data.payload.progress === 1) {
                setTimeout(() => {
                    this.gb.emitters.emit.web.gameLoadEnd();
                }, 100);
            }
        } catch (e) {
            //
        }
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.SPIN:
                event["progress"] = this.SPIN_handler;
                break;
            case constants.WZD:
                event["loadProgress"] = this.WZD_handler;
                break;
            case constants.ENDOR:
                event["gameLoadProgress"] = this.ENDOR_handler;
                break;
            default:
                event["loadProgress"] = this._default;
        }

        return event;
    }
}
